module.exports = __webpack_public_path__ + "img/footer_bg.54706c41.png";